import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useAuthStore from "store/authStore";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const compactParams = (params = {}) => {
	const nullish = [null, "", undefined, Number.NaN, "null", "undefined", "NaN"];

	return Object.entries(params).reduce((acc, [key, value]) => {
		if (!nullish.includes(value)) {
			acc[key] = value;
		}
		return acc;
	}, {});
};

const useGetUserNotifications = (queryParams = {}) => {
	const { accessToken } = useTokenStore();
	const loggedIn = useAuthStore((state) => state.loggedIn);

	const params = compactParams(queryParams);

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const res = await instance.get("notifications/all", {
			params,
		});
		return res.data;
	};

	return useQuery(["notifications", params], fetch, {
		...fetchConfig,
		enabled: loggedIn,
	});
};

export default useGetUserNotifications;
